__turbopack_context__.v({
  "about": "About-module-scss-module__muWqsG__about",
  "aboutContainer": "About-module-scss-module__muWqsG__aboutContainer",
  "certCount0": "About-module-scss-module__muWqsG__certCount0",
  "certCount1": "About-module-scss-module__muWqsG__certCount1",
  "certCount2": "About-module-scss-module__muWqsG__certCount2",
  "certCount3": "About-module-scss-module__muWqsG__certCount3",
  "certificationsContainer": "About-module-scss-module__muWqsG__certificationsContainer",
  "certificationsMobileContainer": "About-module-scss-module__muWqsG__certificationsMobileContainer",
  "contactMobileContainer": "About-module-scss-module__muWqsG__contactMobileContainer",
  "detailsContainer": "About-module-scss-module__muWqsG__detailsContainer",
  "leftGradient": "About-module-scss-module__muWqsG__leftGradient",
  "locationAndSocialContainer": "About-module-scss-module__muWqsG__locationAndSocialContainer",
  "mobile": "About-module-scss-module__muWqsG__mobile",
  "rightGradient": "About-module-scss-module__muWqsG__rightGradient",
  "servicesMobileContainer": "About-module-scss-module__muWqsG__servicesMobileContainer",
  "showLessMode": "About-module-scss-module__muWqsG__showLessMode",
  "showMore": "About-module-scss-module__muWqsG__showMore",
});
